import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { NewEntryPage } from '~/features/entry-form/new-entry-page';

/**
 * `?sign=in|out` opens a both-ways record on that way, as a Cash in or a Cash
 * out button means it to. `?stocking=1` is a list being filled for the first
 * time, from the field that will read it: the title says "Add to …".
 * `?refused=<op>` opens a new entry the server refused, to put right and send
 * again or discard (B10 of the ledger live test): the sync band's Put it
 * right, and OS's card's Edit after a refused confirm.
 */
const search = z.object({
  sign: z.enum(['in', 'out']).optional().catch(undefined),
  stocking: z.coerce.boolean().optional().catch(undefined),
  refused: z.string().optional().catch(undefined),
});

/** A new entry is a page of its own (web-redesign-05 Decided 7), for a record and for a list. */
function NewEntryRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { sign, stocking, refused } = Route.useSearch();
  return <NewEntryPage key={`${recordId}:${refused ?? ''}`} recordId={recordId} direction={sign} stocking={stocking === true} refused={refused} />;
}

export const Route = createFileRoute('/_app/records/$recordId/new-entry')({
  validateSearch: search,
  component: NewEntryRoute,
});
